import { render, staticRenderFns } from "./QAValidation.vue?vue&type=template&id=63246f09&scoped=true"
import script from "./QAValidation.vue?vue&type=script&lang=js"
export * from "./QAValidation.vue?vue&type=script&lang=js"
import style0 from "./QAValidation.vue?vue&type=style&index=0&id=63246f09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63246f09",
  null
  
)

export default component.exports